import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { forwardRef } from "react";
const SvgLoader = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 72, height: 72, viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M42.0957 68.6211C42.3812 70.1489 41.3743 71.6305 39.8288 71.7958C35.4936 72.2595 31.102 71.9327 26.8696 70.8229C21.7279 69.4748 16.9486 67.0048 12.8749 63.5904C8.80111 60.1759 5.53401 55.9017 3.30821 51.0747C1.47599 47.1013 0.386788 42.8344 0.0858532 38.4848C-0.0214253 36.9343 1.26141 35.684 2.8156 35.6981C4.3698 35.7123 5.60471 36.9862 5.73444 38.535C6.02907 42.0526 6.93534 45.4993 8.41945 48.7178C10.2973 52.7901 13.0535 56.3961 16.4904 59.2767C19.9272 62.1573 23.9593 64.2411 28.2971 65.3785C31.7254 66.2774 35.2775 66.5674 38.7924 66.2429C40.34 66.1 41.8102 67.0933 42.0957 68.6211Z", fill: "#9D4C6C" }),
  /* @__PURE__ */ jsx("circle", { cx: 35.9999, cy: 36.0006, r: 14.6667, fill: "#9D4C6C" })
] });
const ForwardRef = forwardRef(SvgLoader);
export default ForwardRef;
